import React from 'react'
import { Link } from 'react-router-dom'

function ServicesTechDigit() {
    const services = [
        {
            num: '01',
            title: 'Medical Billing & Revenue Cycle Management For US Healthcare Providers — All Specialties',
            p1: 'The average in-house billing team runs denial rates between 15 and 25 percent. Our clients average 5 to 8. That gap is real revenue already earned, already owed, just never collected because the process broke down somewhere between the claim going out and the payment coming back.',
            p2: 'Outsourcing your revenue cycle to TechDigit typically reduces billing overhead by 40 to 60 percent while getting you faster submissions, lower denial rates and systematic follow-up that actually recovers what\'s owed.',
            cta: 'Explore Medical Billing Services',
            link: '/medical-billing',
        },
        {
            num: '02',
            title: 'Cybersecurity Services For Businesses Across All Industries — Every Size',
            p1: 'Attackers do not filter by industry or company size. They filter by vulnerability. Forty-three percent of cyberattacks target small and mid-size businesses specifically because they assume defenses are not in place.',
            p2: 'TechDigit delivers fully managed enterprise-grade cybersecurity perimeter protection, Zero Trust architecture, around-the-clock security monitoring, endpoint threat detection and response, advanced email security, identity and access controls and an incident response team that activates in under 15 minutes. Built around your actual risk profile. Not a generic package designed for someone else.',
            cta: 'Explore Cybersecurity Services',
            link: '/cybersecurity',
        },
        {
            num: '03',
            title: 'Call Center & Customer Support Outsourcing For Any Business That Talks to Customers',
            p1: 'Eighty-five percent of callers who reach voicemail do not call back. They call your competitor. Whether you run a medical practice, an e-commerce store, a law firm, a SaaS platform or a home services business, unanswered calls and undertrained agents are costing you customers you will never get back.',
            p2: 'Our agents answer with your name, follow your protocols and represent your brand the way your best team member would: every call, every channel, every industry. Call answer rates above 95 percent. Staffing costs are typically 40 to 60 percent lower than building equivalent in-house coverage.',
            cta: 'Explore Call Center Services',
            link: '/call-center',
        },
        {
            num: '04',
            title: 'Professional Ebook & Whitepaper Writing For Businesses and Authors in Any Industry',
            p1: 'Buyers do not make serious decisions based on blog posts. They base them on whitepapers, buyer\'s guides and research reports that demonstrate the author understands the problem at a level most competitors simply do not reach.',
            p2: 'TechDigit\'s content team ghostwrites and produces research-backed long-form content for technology companies, healthcare organizations, financial firms, coaches, consultants and authors, spanning fiction, nonfiction, self-help, business and beyond. Delivered in 3 to 8 weeks. Unlimited revisions. Published entirely under your name.',
            cta: 'Explore Content Writing Services',
            link: '/ebook-whitepaper-writing',
        },
    ]

    const sectionTitle =
        services.length === 3
            ? 'Three Services. One Standard of Excellence.'
            : 'Four Services. One Standard of Excellence.'

    const renderServiceCard = (svc) => (
        <div className="service-techdigit-card td-service-card">
            <span className="service-num">{svc.num}</span>
            <h4 className="inner title">{svc.title}</h4>
            <p className="disc">{svc.p1}</p>
            <p className="disc">{svc.p2}</p>
            <Link to={svc.link} className="rts-btn btn-primary">
                → {svc.cta}
            </Link>
        </div>
    )

    return (
        <div className="services-techdigit td-section rts-service-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="td-section-head text-center mb-5">
                            <p className="td-section-label">Our Services</p>
                            <h2 className="td-section-title">{sectionTitle}</h2>
                            <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                {services.length === 3 ? (
                    <>
                        <div className="row g-4 g-xl-5">
                            {services.slice(0, 2).map((svc) => (
                                <div key={svc.link} className="col-12 col-lg-6">
                                    {renderServiceCard(svc)}
                                </div>
                            ))}
                        </div>
                        {/* gx only on 2nd row — full `g-*` adds a large margin-top on the first column of a new row */}
                        <div className="row gx-4 gx-xl-5 gy-0 justify-content-center services-techdigit__row-second">
                            <div className="col-12 col-lg-6">
                                {renderServiceCard(services[2])}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="row g-4 g-xl-5">
                        {services.map((svc) => (
                            <div key={svc.link} className="col-lg-6 col-md-12">
                                {renderServiceCard(svc)}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ServicesTechDigit
